// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Cabinet_loadingWrapper__patUa","messageWrapper":"Cabinet_messageWrapper__ITkk3"};